import {useCallback, useState} from 'react';

import {DateRangeFilter} from 'src/openapi/admin/models/DateRangeFilter';

import {DateFilterState, SortDirectionType} from '../../../typedef';


type UseDateFilterProps = {
    onDateFilterChange?: (field: 'createDate' | 'lastRun' | 'lastShared', filter: DateRangeFilter | undefined) => void,
    field: 'createDate' | 'lastRun' | 'lastShared',
};

export const useDateFilter = ({onDateFilterChange, field}: UseDateFilterProps) => {
    const [startDate, setStartDate] = useState<string | undefined>(undefined);
    const [endDate, setEndDate] = useState<string | undefined>(undefined);
    const [sortDirection, setSortDirection] = useState<SortDirectionType>(null);

    const handleApplyFilter = useCallback(() => {
        const dateRangeFilter: DateRangeFilter | undefined =
            (startDate || endDate) ? {
                startDate,
                endDate,
            } : undefined;
        onDateFilterChange?.(field, dateRangeFilter);
    }, [startDate, endDate, onDateFilterChange, field]);

    const handleResetFilter = useCallback(() => {
        setStartDate(undefined);
        setEndDate(undefined);
        onDateFilterChange?.(field, undefined);
    }, [onDateFilterChange, field]);

    const handleCancelFilter = useCallback(() => {
        // Reset to previous values - for simplicity, just reset to undefined
        setStartDate(undefined);
        setEndDate(undefined);
    }, []);

    const dateFilterState: DateFilterState = {
        startDate,
        endDate,
        sortDirection,
        handlers: {
            onApply: handleApplyFilter,
            onReset: handleResetFilter,
            onCancel: handleCancelFilter,
            onStartChange: setStartDate,
            onEndChange: setEndDate,
        },
        isActive: !!(startDate || endDate),
    };

    return {
        dateFilterState,
        setSortDirection,
    };
};
